import { render } from "./ProfilePage.vue?vue&type=template&id=13b88546&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/profile/ProfilePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13b88546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13b88546', __exports__)) {
    api.reload('13b88546', __exports__)
  }
  
  module.hot.accept("./ProfilePage.vue?vue&type=template&id=13b88546&ts=true", () => {
    api.rerender('13b88546', render)
  })

}


export default __exports__